module.exports = __webpack_public_path__ + "static/img/near_icon.20e2b66a.svg";